module.exports = __webpack_public_path__ + "static/media/lowPrice.4f09a21a.jpg";